export default __webpack_public_path__ + "static/media/home-toothbrush.14580db2.png";